// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__UzCge","content":"LayoutSettings_content__3Fx8k"};